export function Create(organizationID: number): string {
	return `/v1/organizations/${organizationID}/lineups`;
}

export function Delete(organizationID: number, lineupID: number): string {
	return `/v1/organizations/${organizationID}/lineups/${lineupID}`;
}

export function Show(organizationID: number, lineupID: number): string {
	return `/v1/organizations/${organizationID}/lineups/${lineupID}`;
}

export function Update(organizationID: number, lineupID: number): string {
	return `/v1/organizations/${organizationID}/lineups/${lineupID}`;
}

